/**
 * @generated SignedSource<<ec835b20f7af0ddf4f5feab1a625a040>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paywallsGetArticlePaywallTagArticle$data = {
  readonly flag: string | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsArchiveWallArticle" | "helpersIsLiteWallArticle" | "helpersIsSignInWallArticle" | "helpersIsVelocityWallArticle" | "hooksVelocityWallThresholdABTest">;
  readonly " $fragmentType": "paywallsGetArticlePaywallTagArticle";
};
export type paywallsGetArticlePaywallTagArticle$key = {
  readonly " $data"?: paywallsGetArticlePaywallTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"paywallsGetArticlePaywallTagArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paywallsGetArticlePaywallTagArticle"
};

(node as any).hash = "468a492e8e4a1978f83f5521fdfdec2b";

export default node;
